/**
 * Features - 功能特性展示组件
 * 以卡片网格形式展示应用的核心功能
 */
export class Features {
  constructor(options = {}) {
    this.title = options.title || '核心功能';
    this.items = options.items || [];
  }

  render() {
    const section = document.createElement('section');
    section.className = 'features section section--alt';
    section.innerHTML = `
      <div class="container">
        <h2 class="heading-lg" style="text-align:center; margin-bottom: var(--space-12);">
          ${this.title}
        </h2>
        <div class="grid grid--3">
          ${this.items.map((item) => `
            <div class="card feature-card">
              <div class="feature-card__icon">${item.icon || ''}</div>
              <h3 class="heading-md" style="margin: var(--space-4) 0 var(--space-2);">
                ${item.title}
              </h3>
              <p class="text-muted">${item.description || ''}</p>
            </div>
          `).join('')}
        </div>
      </div>
    `;
    return section;
  }
}
